<script setup lang="ts">
import BtnTemplate from './template.vue'

type Props = {
  selected?: boolean
  small?: boolean
}
const { selected = false, small = false } = defineProps<Props>()

type Emits = {
  click: [MouseEvent]
}
const emit = defineEmits<Emits>()
</script>

<template>
  <BtnTemplate
    class="outlined"
    :class="{ selected, small }"
    @click="emit('click', $event)"
  >
    <span class="btnText">
      <slot />
    </span>
  </BtnTemplate>
</template>
